<template>
  <div
    class="PushNotification"
    aria-hidden="true"
    :data-is-visible="isVisible"
  >
    <div
      class="PushNotification__wrapper"
    >
      <div class="PushNotification__iconContainer">
        <Basketball class="PushNotification__icon" />
      </div>
      <div class="PushNotification__content">
        <div class="PushNotification__title">
          Ball.app
        </div>
        <div class="PushNotification__body">
          <slot>
            {{ body }}
          </slot>
        </div>
      </div>
      <div class="PushNotification__timestamp">
        now
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Basketball from "./Basketball.vue";

const {
  isVisible = true,
} = defineProps<{
  body?: string,
  isVisible?: boolean,
}>();
</script>

<style lang="scss" scoped>
.PushNotification {
  position: relative;
  max-width: 340px;
}

.PushNotification__wrapper {
  position: relative;
  isolation: isolate;

  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 16px;

  color: var(--themeColorWhite);

  font-stretch: var(--fontWidthExtended);

  transition: 500ms var(--easeOutCubic);
  transition-property: transform, opacity;

  &::before {
    position: absolute;
    inset: 0;
    z-index: -1;

    border-radius: 24px;
    background-color: var(--themeDarkTransparent500);

    @container style(--themeColorPrimary: #000) {
      background-color: var(--themeLightTransparent200);
    }

    content: "";
  }

  [data-is-visible="false"] & {
    transform: translateX(-100%);
    opacity: 0;
  }
}

.PushNotification__iconContainer {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 38px;
  height: 38px;

  border-radius: 8px;
  background-color: var(--themeColorPrimary);
}

.PushNotification__icon {
  width: 26px;
  height: 26px;

  border-radius: 50%;
  outline: 2px solid var(--themeColorWhite);
}

.PushNotification__content {
  display: grid;
  gap: 2px;
}

.PushNotification__title {
  font-size: 15px;
  font-weight: var(--fontWeightMedium);
}

.PushNotification__body {
  font-size: 14px;
  line-height: 18px;
}

.PushNotification__timestamp {
  position: absolute;
  top: 14px;
  right: 16px;

  font-size: 12px;
}
</style>
